import { ts_hocsinh_lichsu_yte_loaithuoc } from '../models/response/category/ts_hocsinh_lichsu_yte_loaithuoc';
import { apiClient } from './apiClient';
import { apiGuestClient } from './apiGuestClient';

export const LOAI_THUOC_API_END_POINT = "loai-thuoc";

export const loaiThuocApi = {
    // Lấy tất cả loại thuốc
    selectAll: () => apiGuestClient.get(`${LOAI_THUOC_API_END_POINT}`),

    // Lấy tất cả loại thuốc với thông tin đơn vị tính
    selectAllView: () => apiGuestClient.get(`${LOAI_THUOC_API_END_POINT}/view`),

    // Lấy chi tiết loại thuốc theo ID
    detail: (id: number) => apiClient.get(`${LOAI_THUOC_API_END_POINT}/${id}`),

    // Thêm mới loại thuốc
    insert: (data: ts_hocsinh_lichsu_yte_loaithuoc) => apiClient.post(`${LOAI_THUOC_API_END_POINT}`, data),

    // Cập nhật loại thuốc
    update: (data: ts_hocsinh_lichsu_yte_loaithuoc) => apiClient.put(`${LOAI_THUOC_API_END_POINT}`, data),

    // Xóa loại thuốc
    delete: (id: number) => apiClient.delete(`${LOAI_THUOC_API_END_POINT}/${id}`),
};
